// eslint-disable-next-line import/no-named-default
import { default as MasterBusinessTrx } from "./BusinessTrx";

export default MasterBusinessTrx;
